module.exports = __webpack_public_path__ + "img/vdb_logo.ff5fd73e.png";